/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type Meta, type StoryObj } from '@storybook/react-vite';

import { ButtonBase } from '..';
import {
  ButtonDisabled,
  ButtonDisabledSrc,
  ButtonFloating,
  ButtonFloatingSrc,
  ButtonFluid,
  ButtonFluidSrc,
  ButtonLeadingIcon,
  ButtonLeadingIconSrc,
  ButtonLoading,
  ButtonLoadingSrc,
  ButtonSizes,
  ButtonSizesSrc,
  ButtonVariants,
  ButtonVariantsSrc,
} from '.';

const componentMeta: Meta<typeof ButtonBase> = {
  component: ButtonBase,
  decorators: [
    (Story) => (
      <div className="n-flex n-justify-center n-w-full">
        <Story />
      </div>
    ),
  ],
  id: 'components-button',
  parameters: {
    controls: { disable: true },
  },
  title: 'Components/Button',
} satisfies Meta<typeof ButtonBase>;

export default componentMeta;
type Story = StoryObj<typeof componentMeta>;

export const Sizes: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ButtonSizesSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ButtonSizes,
};

export const WithLeadingVisual: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ButtonLeadingIconSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ButtonLeadingIcon,
};

export const Fluid: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ButtonFluidSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ButtonFluid,
};

export const Variants: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ButtonVariantsSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ButtonVariants,
};

export const Loading: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ButtonLoadingSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ButtonLoading,
};

export const Disabled: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ButtonDisabledSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ButtonDisabled,
};

export const Floating: Story = {
  args: {},
  parameters: {
    docs: {
      source: {
        code: ButtonFloatingSrc,
        language: 'tsx',
        type: 'code',
      },
    },
  },
  render: ButtonFloating,
};
